
//ヘッダー
import Header from '../../component/page_parts/header';
// フッター
import Footer from '../../component/page_parts/footer';

// bootstrap
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// パンくずリスト
import TableOfContents from "../../component/page_parts/common/table_of_contents";

import React from 'react';
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet-async';

const baseUrl = process.env.REACT_APP_PUBLIC_URL || '';

type LogoItem = {
  id: number;
  title: string;
  img: string;
  tag: string;
  href?: string;
  width?: number;
};

type LogoSection = {
  id: number;
  title?: string;
  subtitle?: string;
  items: LogoItem[];
};

const sections: LogoSection[] = [
  {
    id: 1,
    title: 'Zenkenオフィシャル',
    items: [
      { id: 1, title: 'Zenkenコーポレートロゴ', img: '/zenken-logo.png', tag: 'コーポレート', href: '/logoguide/detail?l=official&id=1', width: 140 },
      { id: 2, title: '50周年ロゴ', img: '/zenken-50year-logo.png', tag: 'コーポレート', href: '/logoguide/detail?l=official&id=2', width: 184 },
    ],
  },
  {
    id: 2,
    title: 'コーポレート・サービスロゴ（あいうえお順）',
    subtitle: '［あ行］',
    items: [
      { id: 46, title: 'AISE国際交流センター', img: '/aise-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=46', width: 225 },
      { id: 49, title: '麻布台留学パートナーズ', img: '/azabudairyugaku-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=49', width: 222 },
      { id: 31, title: 'Yaaay', img: '/yaaay-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=31', width: 193 },
      { id: 30, title: 'Yaaay Freshers', img: '/yaaay-freshers-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=30', width: 165 },
      { id: 47, title: '一般財団法人海外留学推進協会', img: '/study Abroad Association_logo.png', tag: 'コーポレート', href: '/logoguide/detail?l=service&id=47', width: 204 },
      { id: 17, title: 'エンゲージメンター', img: '/engage_mentor-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=17', width: 204 },
      { id: 43, title: 'おもてなし英会話', img: '/omotenashi-eikaiwa-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=43', width: 211 },
      { id: 44, title: 'おもてなし英会話　心・旅館編', img: '/omotenashi-eikaiwa-kokororyokanhenn-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=44', width: 196 },
    ],
  },
  {
    id: 3,
    subtitle: '［か行］',
    items: [
      { id: 15, title: 'キャククル', img: '/kyakukuru.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=15', width: 170 },
      { id: 50, title: 'グローバル人材育成ラボ', img: '/grobal-jinnzaiikuseilabo-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=50', width: 205 },
      { id: 45, title: 'グローバルスタディ', img: '/globalstudy-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=45', width: 210 },
      { id: 38, title: '健康美容EXPO', img: '/health_beauty_expo-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=38', width: 211 },
    ],
  },
  {
    id: 4,
    subtitle: '［さ行］',
    items: [
      { id: 19, title: 'ジャパンニッチトップ', img: '/japan niche top-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=19', width: 92 },
      { id: 14, title: '職ブラ', img: '/syokubura-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=14', width: 198 },
      { id: 13, title: '戦コン　グローバル', img: '/sennkonn-global-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=13', width: 176 },
      { id: 12, title: '戦コン　ブラメ', img: '/sennkonn-burame-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=12', width: 180 },
      { id: 11, title: '戦コン　ポジメ', img: '/sennkonn-posime-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=11', width: 185 },
      { id: 33, title: 'ZENKEN 介護', img: '/zenken_kaigo-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=33', width: 198 },
      { id: 35, title: '全研ケア', img: '/zenken-care-logo.png', tag: 'コーポレート', href: '/logoguide/detail?l=service&id=35', width: 198 },
      { id: 34, title: 'ZENKEN 宿泊', img: '/zenken-syukuhaku-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=34', width: 215 },
      { id: 32, title: 'ZENKEN NIHONGO 介護', img: '/zenken-nihonngo-kaigo-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=32', width: 228 },
      { id: 66, title: 'Zenken LifeCare', img: '/zenkenLifeCare_logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=66'},
      { id: 36, title: '全研リビング', img: '/zenken-living-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=36', width: 190 },     
    ],
  },
  {
    id: 5,
    subtitle: '［は行］',
    items: [
      { id: 37, title: '美プロ', img: '/bipro-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=37', width: 104 },
      { id: 48, title: '米国大学スカラーシップ協会', img: '/scholarshiplogo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=48', width: 187 },
      { id: 18, title: 'ページデリバリー', img: '/pagedelivery-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=18', width: 190 },
      { id: 16, title: 'VOiCE', img: '/voice-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=16', width: 167 },
    ],
  },
  {
    id: 6,
    subtitle: '［ら行］',
    items: [
      { id: 20, title: 'らいく', img: '/raiku-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=20', width: 175 },
      { id: 40, title: 'リンゲージ', img: '/linguage-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=40', width: 171 },
      { id: 41, title: 'リンゲージスピーク', img: '/linguage-speak-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=41', width: 212 },
      { id: 42, title: 'リンゲージ日本語学校', img: '/linguage-japanese-school-logo.png', tag: 'サービスロゴ', href: '/logoguide/detail?l=service&id=42', width: 204 },
    ],
  },
  {
    id: 7,
    title: '過去ロゴアーカイブ（※使用不可）',
    items: [
      { id: 60, title: 'てびきびと', img: '/tebikibito-logo.png', tag: '', width: 205 },
      { id: 61, title: 'ライターステーション', img: '/raisute-logo.png', tag: '', width: 222 },
      { id: 62, title: 'テビキ', img: '/tebiki-logo.png', tag: '', width: 183 },
      { id: 63, title: 'サイト良くして委員会', img: '/saiteyokushiteiinnkai-logo.png', tag: '', width: 191 },
      { id: 64, title: 'まちコン　ポータル', img: '/machikon-logo.png', tag: '', width: 168 },
    ],
  },
];



// ロゴ一覧ページ
function logoguide() {

  // GAID
  var gaId = process.env.REACT_APP_GA_ID;

  const element = document.getElementById("left-tabs-example-tab-first1");
  const userName = localStorage.getItem("user_name") || 'Unknown User'; // Provide a default value
  if (gaId) { // Check if gaId is defined
    ReactGA.initialize(gaId);
    ReactGA.send({
      hitType: "event",
      eventCategory: userName,
      eventAction: '委員会-タブ切り替え',
      eventLabel: element?.textContent,
    });
  }

  // GA4タブ押下時計測
  function sendTabNameToGoogleAnalytics(e: React.MouseEvent<HTMLButtonElement>) {
    var element = document.getElementById(e.currentTarget.id); // 'e.currentTarget' を使用して安全に要素にアクセス
    var userName = localStorage.getItem("user_name") || 'Unknown User'; // Provide a default value
    console.log(element?.textContent);
    if (gaId) { // Check if gaId is defined
      ReactGA.initialize(gaId);
      ReactGA.send({
        hitType: "event",
        eventCategory: userName,
        eventAction: '委員会-タブ切り替え',
        eventLabel: element?.textContent,
      });
    }
  }

  return (
    <>
      <Helmet>
        <title>Z-link ロゴガイド</title>
      </Helmet>
      <Header />
      <div className="theme-logoguide">
        <div className="content-header">
          <div className="container">
            <Row>
              <Col sm={7}>
                <h1 className='page-title type-logoguide'>ロゴガイド</h1>
                <p className="description">Zenkenの使用可能なロゴです。規定に沿って適切に使用するようにお願いします。</p>
              </Col>
              <Col sm={5} className="align-bottom align-self-center mb-4">
                  <div className="page-title-area">
                    <button className="btn-link-area">
                      <a href="https://forms.gle/Bw6WbJVi4S9y8M4d7" target='_blanck'>ロゴの新規・変更・抹消フォーム</a>
                    </button>
                  </div >
              </Col >
            </Row>
          </div>
        </div>
        <TableOfContents />
        <div className="container">
        {sections.map((section, index) => {
  const prevSection = sections[index - 1];
  const isSameTitle = prevSection && prevSection.title === section.title;
  const isFirst = index === 0;
  const isSecond = index === 1;
  const isLast = index === sections.length - 1;
  const isKaigaiSegment = section.title === '海外人材セグメント';

  return (
    <div
      key={section.id}
      className={`logo-section
        ${isFirst ? 'first' : ''}
        ${isLast ? 'end' : ''}`}
    >
    {!isSameTitle && section.title && section.title.trim() !== '' && (
      <h2
        className={`tag-title ${isKaigaiSegment ? 'kaiaisegument' : ''} ${isSecond ? 'second' : ''}`}
      >
        {section.title}
      </h2>
)}

      {/* subtitle：常に表示、2回目以降は second */}
      {section.subtitle && (
        <h3
          className={`tag-subtitle
             ${isSameTitle ? 'second' : ''}
             `}
        >
          {section.subtitle}
        </h3>
      )}

      <div className="logo-card-grid">
      {section.items.map((item) => {
  const CardTag = item.href ? 'a' : 'div';

  return (
    <CardTag
      key={item.id}
      className="logo-card"
      {...(item.href ? { href: baseUrl + item.href } : {})}
    >
      <div className="logo-card__image">
      <img
        src={item.img}
        alt={item.title}
        style={item.width ? { width: `${item.width}px`, maxWidth: "none" } : undefined}
      />
      </div>

      <p className="logo-card__title">{item.title}</p>

      {item.tag && (
        <span
          className={`logo-card__tag ${
            item.tag === 'コーポレート'
              ? 'logo-card__tag--corporate'
              : 'logo-card__tag--service'
          }`}
        >
          {item.tag}
        </span>
      )}
    </CardTag>
  );
})}

      </div>
    </div>
  );
})}




        </div>
      </div>
      <Footer />
    </>
  );
}

export default logoguide;